import { proxy } from 'valtio'

const app = proxy({
  collapsed: false,
  announcements: [],
})

export default app
